import {memo} from 'react';
import Chart from "react-apexcharts";
import {Typography} from "@material-tailwind/react";
import {isDarkMode} from "../../App";
import {useTranslation} from "react-i18next";
import Loader from "../../assets/icons/Loader";

export interface LinearChartProps {
    series: {
        name: string,
        data: number[]
    }[],
    labels: string[],
    isLoading: boolean
}

const LinearChart = ({series, labels, isLoading = true}: LinearChartProps) => {
    const {t} = useTranslation();
    const colors = [
        '#00695c',
        '#607d8b',
        '#33691e',
        '#ffca28',
        '#9ccc65',
        '#26a69a',
        '#d84315',
        '#039be5',
        '#9c27b0',
        '#ff5722',
        '#d84315',
        '#ef5350',
    ];

    const element = document.getElementById('successful_deposits_linear');
    const hasLength = series.length && typeof series[0] !=='undefined' && series[0].data.length;
    return <>
        {hasLength ? <Chart type="line"
                                width={element ? element.offsetWidth - 16 : '100%'}
                                height={element ? element.offsetHeight - 100 : '100%'}
                                series={series}
                                options={{
                                    xaxis: {
                                        axisTicks: {
                                            show: false,
                                        },
                                        axisBorder: {
                                            show: false,
                                        },
                                        categories: labels
                                    },
                                    grid: {
                                        borderColor: '#eee'
                                    },
                                    chart: {
                                        toolbar: {
                                            show: false,
                                        },
                                        background: 'transparent'
                                    },
                                    stroke: {
                                        lineCap: "round",
                                        curve: "smooth",
                                    },
                                    dataLabels: {
                                        enabled: false
                                    },
                                    yaxis: {
                                        labels: {
                                            style: {
                                                colors: isDarkMode? '#ccc' : "#616161",
                                                fontSize: "12px",
                                                fontFamily: "inherit",
                                                fontWeight: 400,
                                            },
                                            formatter: (val) => {
                                                return Intl.NumberFormat('en-US', {
                                                    notation: "compact",
                                                    maximumFractionDigits: 1
                                                }).format(val);
                                            }
                                        }
                                    },
                                    colors: isDarkMode? colors.reverse() : colors,
                                    tooltip: {
                                        theme: isDarkMode? 'dark': 'light',
                                        cssClass: 'text-center'
                                    },
                                    theme: {
                                        mode: isDarkMode? 'dark': 'light'
                                    }
                                }}
        /> : <>
            <Chart type="line"
                   width={element ? element.offsetWidth - 16 : '100%'}
                   height={element ? element.offsetHeight - 100 : '100%'}
                   series={[{name: 'No data', data: []}]}
                   options={{
                       labels: labels,
                       legend: {
                           show: false
                       },
                       dataLabels: {
                           enabled: false
                       },
                       colors: ['#cfd8dc'],
                       plotOptions: {
                           pie: {
                               expandOnClick: false
                           }
                       },
                       chart: {
                           animations: {
                               enabled: false
                           },
                           zoom: {
                               enabled: false
                           },
                           toolbar: {
                               show: false
                           },
                           background: 'transparent'
                       },
                       grid: {
                           borderColor: '#eee'
                       },
                       states: {
                           active: {
                               filter: {
                                   type: 'none'
                               },
                           },
                           hover: {
                               filter: {
                                   type: 'none'
                               }
                           }
                       },
                       tooltip: {
                           enabled: false
                       },
                       theme: {
                           mode: isDarkMode? 'dark': 'light'
                       }
                   }}
            />
            {!isLoading ? <Typography variant="small" className="mb-4 text-center absolute w-full top-1/2">{t('No data')}</Typography>: ''}
        </>}
        {isLoading ? <div
            className="absolute w-full h-full bg-white dark:bg-black top-0 left-0 opacity-30 flex items-center justify-center rounded-xl">
            <Loader width="w-8 h-8" colors="text-teal-600 fill-white"/>
        </div> :''}
    </>
}

export default memo(LinearChart);
